// @flow

import { useEffect } from 'react';
import type { MessageResponseError } from '../../../store/types';
import { __ } from '../../../i18n/l10n';

export const useCheckForm = (
  getValues: Function,
  schema: Object,
  setFormValid: Function,
  error: ?MessageResponseError,
  setError: Function
) => {
  // Websocket errors
  useEffect(() => {
    if (error && error.data && error.data.field_violations) {
      error.data.field_violations.forEach((violation) => {
        setError(violation.field, '', __(violation.error));
      });
    }
  }, [error, setError]);

  const checkForm = async () => {
    const data = getValues();

    schema
      .validate(data)
      .then(() => {
        setFormValid(true);
      })
      .catch((validationError) => {
        setFormValid(false);
      });
  };

  checkForm();

  return [checkForm];
};
